import React from 'react';
import { useLocale } from '../../context/LocaleContext';
import { BarChart3, Camera, FileText, Lock, Repeat, Rocket, ShieldCheck, Smartphone, Truck, Zap } from 'lucide-react';

const FEATURE_ICONS = [Lock, Zap, Smartphone, Camera, ShieldCheck, Rocket, Truck, FileText, Repeat, BarChart3];
const FEATURE_GLOWS = [
  'rgba(245, 147, 0,0.3)', 'rgba(255, 176, 32,0.3)', 'rgba(52, 195, 160,0.3)',
  'rgba(249,115,22,0.3)', 'rgba(245, 147, 0,0.3)', 'rgba(255, 176, 32,0.3)',
  'rgba(16,185,129,0.3)', 'rgba(255, 176, 32,0.3)', 'rgba(249,115,22,0.3)',
  'rgba(52, 195, 160,0.3)',
];

// index.tsx'ten ayrıştırıldı — landing "Features" bölümü
export default function Features({ L }: any) {
  const { locale, brandName } = useLocale();
  const FEATURES = L.features.items.map((f: any, i: number) => ({ ...f, icon: FEATURE_ICONS[i], glow: FEATURE_GLOWS[i] }));
  return (
    <>
        <section id="features" className="py-16 md:py-24 relative">
          <div className="divider-glow mb-0 mx-12" />
          <div className="max-w-7xl mx-auto px-6 pt-16">
            <div className="text-center mb-20">
              <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#F59300] uppercase tracking-widest font-semibold mb-4">
                {L.features.badge}
              </div>
              <h2
                className="reveal reveal-delay-1 text-4xl md:text-5xl font-black text-white mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {L.features.titlePrefix} <span className="gradient-text">{brandName}?</span>
              </h2>
              <p className="reveal reveal-delay-2 text-gray-400 text-lg max-w-xl mx-auto">
                {L.features.subtitle}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {FEATURES.map((f, i) => {
                const isFirstCorporate = i === 6;
                const FeatIcon = f.icon;
                return (
                  <React.Fragment key={i}>
                    {isFirstCorporate && (
                      <div className="col-span-1 md:col-span-2 lg:col-span-3 mt-12 mb-6 flex flex-col items-center">
                        <span className="text-xs font-black tracking-widest text-[#FFB020] uppercase bg-[#FFB020]/10 border border-[#FFB020]/20 px-3.5 py-1.5 rounded-full mb-3 shadow-lg shadow-[#FFB020]/5">
                          {L.features.corporateBadge}
                        </span>
                        <h3 className="text-2xl font-black text-white tracking-wide text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                          {L.features.corporateTitle}
                        </h3>
                        <div className="w-12 h-1 bg-gradient-to-r from-[#FFB020] to-[#F59300] rounded-full mt-3" />
                      </div>
                    )}
                    <div
                      id={`feature-card-${i}`}
                      className={`reveal reveal-delay-${(i % 3) + 1} tilt-card feature-card glass-panel gradient-border rounded-2xl p-8 relative`}
                      style={{ '--glow': f.glow } as React.CSSProperties}
                    >
                      {f.isCorporate && (
                        <div className="absolute top-4 right-4 bg-[#FFB020]/10 text-[#FFB020] border border-[#FFB020]/25 text-[9px] uppercase font-black px-2.5 py-1 rounded-full tracking-widest">
                          {L.features.corporateTag}
                        </div>
                      )}
                      <div
                        className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 shadow-lg"
                        style={{ background: `${f.glow}`, border: `1px solid ${f.glow}` }}
                      >
                        <FeatIcon size={26} className="text-white" />
                      </div>
                      <h3
                        className="text-lg font-bold text-white mb-3"
                        style={{ fontFamily: 'var(--font-heading)' }}
                      >
                        {f.title}
                      </h3>
                      <p className="text-gray-400 text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </section>

    </>
  );
}
